// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  // --- ADD THESE ---
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  // --- END ADD ---
} from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDmbLlrhLIQ5f8jGNVJVOjBtaoN2oMchds",
  authDomain: "pdf-play-878b9.firebaseapp.com",
  projectId: "pdf-play-878b9",
  storageBucket: "pdf-play-878b9.firebasestorage.app",
  messagingSenderId: "77085838682",
  appId: "1:77085838682:web:e30af11c91f4bbe1e3f763",
  measurementId: "G-1REKZSHEEN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// --- UPDATED EXPORTS ---
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
// Re-export all the functions we need
export {
  signInWithPopup,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
};
// --- END UPDATE ---
